<template>
  <slot v-bind="{ opened, toggle }"></slot>
  <slot name="hidden" v-if="opened" v-bind="{ opened, toggle }"></slot>
</template>

<script>
export default {
  props: {
    forceOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpened: this.forceOpened
    }
  },
  computed: {
    opened() {
      return this.isOpened
    }
  },

  methods: {
    toggle() {
      this.isOpened = !this.isOpened
    }
  }
}
</script>

<style lang="scss" scoped></style>
